import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { SelectComponent as TagsSelectPage } from 'src/app/components/tags/select/select.component';

@Component({
  selector: 'app-team-member-manage-skills',
  templateUrl: './manage-skills.component.html',
  styleUrls: ['./manage-skills.component.scss'],
})
export class ManageSkillsComponent {

  @Input() team_members: any[] = [];
  // The full set of skills the project's tasks require (not just the ones currently missing) - kept
  // separate from `missingSkills` below so the missing list updates live as skills get assigned here.
  @Input() required_skills: any[] = [];
  search_query = '';

  constructor(private modalController: ModalController, private apiService: ApiService) { }

  get filteredMembers(): any[] {
    const query = this.search_query.trim().toLowerCase();
    if (!query) return this.team_members;
    return this.team_members.filter((m: any) =>
      (m.display_name || '').toLowerCase().includes(query) ||
      (m.email || '').toLowerCase().includes(query)
    );
  }

  get missingSkills(): any[] {
    const coveredGuids = new Set<string>();
    this.team_members.forEach((tm: any) => (tm.skills || []).forEach((s: any) => coveredGuids.add(s.guid)));
    return this.required_skills.filter((s: any) => !coveredGuids.has(s.guid));
  }

  dismiss() {
    this.modalController.dismiss();
  }

  async EditSkills(member: any) {
    if (!member.skills) member.skills = [];
    const skills_copy = JSON.stringify(member.skills);
    const modal = await this.modalController.create({
      component: TagsSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        url: 'team_members',
        selected_tags: member.skills,
        title: 'Select Skills',
        source_header: 'Available Skills',
        target_header: 'Assigned Skills',
        name: 'Skill'
      }
    });
    modal.onDidDismiss().then((data: any) => {
      if (data && data.data) {
        this.SyncSkills(member, JSON.parse(skills_copy), data.data);
      } else {
        member.skills = JSON.parse(skills_copy);
      }
    });
    return await modal.present();
  }

  // Diffs old vs new so we only send the skills that actually changed, mirroring the team member details page.
  async SyncSkills(member: any, old_skills: any[], new_skills: any[]) {
    old_skills.forEach(skill => {
      if (!new_skills.find(e => e.guid === skill.guid)) this.RemoveSkill(member, skill);
    });
    new_skills.forEach(skill => {
      if (!old_skills.find(e => e.guid === skill.guid)) this.AddSkill(member, skill);
    });
  }

  async RemoveSkill(member: any, skill: any) {
    await this.apiService.delete(`team_members/skills/${member.guid}`, skill);
  }

  async AddSkill(member: any, skill: any) {
    await this.apiService.post(`team_members/skills/${member.guid}`, skill);
  }
}
